export default __webpack_public_path__ + "static/media/whiteboard.f154801f.png";